import { PageEntity } from "@jackfruit/common"
import { createEntitySlice } from "../createEntitySlice"

export const { slice: pages, selectors: pagesSelector } = createEntitySlice<
  PageEntity
>("pages")
